import React from "react"
import { Icon, Popup, Progress } from "semantic-ui-react"
import shop from "shop/shop"
import Price from "components/Price/Price"
import MediaQuery from "react-responsive"

const MinOrderFreeValue = ( { sum } ) => {
  if ( !shop.config.MIN_ORDER_VALUE ) return null
  const prc = (sum / shop.config.MIN_ORDER_FREE_VALUE) * 100
  const aboveMin = sum > shop.config.MIN_ORDER_FREE_VALUE
  if ( aboveMin || sum === 0 ) return null
  // return <div>{prc}</div>
  return <div className="pt0">
    <MediaQuery minWidth={768}>
      <div>
        <div className="ml0">
          <Progress  size="small" percent={prc} />
        </div>
      </div>
    </MediaQuery>
  </div>
}

export default MinOrderFreeValue


// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Cart/MinOrderFreeValue.js